import React from 'react';
import './LegalPage.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <h1>Privacy Policy</h1>
      <p className="last-updated">Effective: August 2025</p>

      <section className="intro">
        <p>Charlotte Student Hub ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platform.</p>
      </section>

      <section>
        <h2>1. Information Collection</h2>
        <p>We collect several types of information from and about users:</p>
        <ul className="legal-list">
          <li><strong>Personal Data:</strong> Name, email address, academic level when you register</li>
          <li><strong>Usage Data:</strong> Pages visited, time spent, clickstream data</li>
          <li><strong>Technical Data:</strong> IP address, browser type, device characteristics</li>
        </ul>
      </section>

      <section>
        <h2>2. Legal Basis for Processing</h2>
        <p>We process your data based on:</p>
        <ul className="legal-list">
          <li>Your consent (when you create an account)</li>
          <li>Contractual necessity (to provide our services)</li>
          <li>Legitimate interests (service improvement, security)</li>
        </ul>
      </section>

      <section>
        <h2>3. Data Usage</h2>
        <p>We use collected information to:</p>
        <ul className="legal-list">
          <li>Provide and maintain our service</li>
          <li>Notify you about changes</li>
          <li>Allow participation in interactive features</li>
          <li>Monitor usage patterns</li>
          <li>Detect and prevent technical issues</li>
        </ul>
      </section>

      <section>
        <h2>4. Data Protection</h2>
        <p>We implement appropriate technical and organizational measures including:</p>
        <ul className="legal-list">
          <li>SSL/TLS encryption for data in transit</li>
          <li>Regular security audits</li>
          <li>Access controls and authentication protocols</li>
          <li>Data minimization principles</li>
        </ul>
      </section>

      <section>
        <h2>5. Data Retention</h2>
        <p>We retain personal data only as long as necessary:</p>
        <ul className="legal-list">
          <li>Account data: Until account deletion request</li>
          <li>Usage data: 12 months from collection</li>
          <li>Legal requirements may necessitate longer retention</li>
        </ul>
      </section>

      <section>
        <h2>6. User Rights</h2>
        <p>You have the right to:</p>
        <ul className="legal-list">
          <li>Access your personal data</li>
          <li>Request correction of inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Object to processing of your data</li>
          <li>Request data portability</li>
        </ul>
      </section>

      <section>
        <h2>7. Cookies & Tracking</h2>
        <p>We use:</p>
        <ul className="legal-list">
          <li><strong>Essential Cookies:</strong> Necessary for basic functionality</li>
          <li><strong>Analytics Cookies:</strong> Google Analytics with anonymized IP</li>
        </ul>
        <p>You can manage preferences via browser settings.</p>
      </section>

      <section>
        <h2>8. Third-Party Services</h2>
        <p>We may use:</p>
        <ul className="legal-list">
          <li>Supabase for data storage (US-based, Privacy Shield certified)</li>
          <li>Cloudflare for security (global CDN)</li>
        </ul>
      </section>

      <section>
        <h2>9. Policy Updates</h2>
        <p>We may update this policy by posting changes on this page. Material changes will be notified via email or platform notice.</p>
      </section>

      <section>
        <h2>10. Data Leaked </h2>
        <p> In the event of a security incident, we will promptly notify affected users and take immediate action to mitigate risks. Our liability is limited as outlined in our Terms of Service, and we strongly recommend users enable 2FA and practice good password hygiene. We will NOT be held responsibe for such event occuring as well. </p>

      </section>
    </div>
  );
};

export default PrivacyPolicy;